import Component from './chat-wrapper';

export default Component;